(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initScroll(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var usesMobileGrid = root.classList.contains('carousel--mobile-grid');

    function slideWidth() {
      var first = track.children[0];
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return first.offsetWidth + gap;
    }

    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function syncArrows() {
      if (!prev || !next) return;
      var max = maxScrollLeft();
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= max - 1 || max === 0;
      prev.disabled = atStart;
      next.disabled = atEnd;
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function visibleCount() {
      var w = slideWidth();
      return w > 0 ? Math.round(track.clientWidth / w) : 1;
    }

    function scrollByItem(direction) {
      var count = (window.innerWidth < 750 && usesMobileGrid) ? visibleCount() : 1;
      var delta = slideWidth() * count * direction;
      if (reducedMotion.matches) {
        track.scrollLeft += delta;
      } else if (typeof track.scrollBy === 'function') {
        track.scrollBy({ left: delta, behavior: 'smooth' });
      } else {
        track.scrollLeft += delta;
      }
    }

    if (prev) prev.addEventListener('click', function () { scrollByItem(-1); });
    if (next) next.addEventListener('click', function () { scrollByItem(1); });

    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollByItem(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByItem(-1); }
      else if (e.key === 'Home') { e.preventDefault(); track.scrollLeft = 0; }
      else if (e.key === 'End') { e.preventDefault(); track.scrollLeft = maxScrollLeft(); }
    });

    // Desktop mouse-drag support (native overflow-x handles touch natively)
    var isDown = false;
    var isDragging = false;
    var startX = 0;
    var startScroll = 0;
    var DRAG_THRESHOLD = 5;
    var suppressClick = false;

    // Suppress native HTML5 image/link drag so it doesn't hijack the pan gesture
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      isDragging = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      suppressClick = false;
      // Prevent the browser from starting a native drag when the press lands on an <img> or <a>
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!isDragging && Math.abs(dx) > DRAG_THRESHOLD) {
        isDragging = true;
        track.classList.add('is-dragging');
      }
      if (isDragging) {
        track.scrollLeft = startScroll - dx;
      }
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      if (isDragging) {
        suppressClick = true;
        track.classList.remove('is-dragging');
        isDragging = false;
      }
    });

    // Swallow the synthetic click that fires after a drag-release
    track.addEventListener('click', function (e) {
      if (!suppressClick) return;
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }, true);
  }

  function initFade(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var slides = root.querySelectorAll('[data-carousel-slide]');
    var dots = root.querySelectorAll('[data-carousel-dot]');
    if (slides.length === 0) return;

    var current = 0;

    function show(index) {
      var target = (index + slides.length) % slides.length;
      var render = function () {
        slides.forEach(function (s, i) {
          var active = i === target;
          s.classList.toggle('is-active', active);
          if (active) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === target);
        });
        current = target;
      };
      if (document.startViewTransition && !reducedMotion.matches) {
        document.startViewTransition(render);
      } else {
        render();
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.carouselDot, 10));
      });
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      else if (e.key === 'Home') { e.preventDefault(); show(0); }
      else if (e.key === 'End') { e.preventDefault(); show(slides.length - 1); }
    });

    if (root.dataset.carouselAutoplay === 'true' && slides.length > 1 && !reducedMotion.matches) {
      var interval = window.setInterval(function () {
        if (!document.body.contains(root)) {
          window.clearInterval(interval);
          return;
        }
        if (document.hidden) return;
        show(current + 1);
      }, 5000);
    }
  }

  function init() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      if (root.dataset.carouselBound === 'true') return;
      root.dataset.carouselBound = 'true';
      if (root.dataset.carouselKind === 'fade') initFade(root);
      else initScroll(root);
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
